import { Pipe, PipeTransform } from '@angular/core';
import { ArticleCategoryDTO } from '@scip/api';

@Pipe({
  name: 'articleCategoryList'
})
export class ArticleCategoryListPipe implements PipeTransform {
  transform(allArticleCategories: ArticleCategoryDTO[]): string {
    // Catch undefined/null and an array without any entry
    if (!allArticleCategories?.length) {
      return '';
    }
    return allArticleCategories.map((category) => category.categorySpecificIdentifier + ':' + category.text).join(', ');
  }
}
